<script>
  import PreviewModal from "../../Shared/previewModal.svelte"
  import TemplatesList from "../../../../../Stores/templatesList"
  import { onMount, createEventDispatcher } from "svelte"
  import templateStore, { templateToJSON } from "../../../../../Stores/metadataStore"

  /**
   * JSON object containing data.
   * @type {object}
   */
  let json = {}

  /**
   * Indicates whether the preview modal is open or closed.
   * @type {boolean}
   */
  let previewModal = false

  const dispatch = createEventDispatcher()

  const closeModal = () => {
    previewModal = !previewModal
    dispatch("closeModal")
    $TemplatesList.showModal = false
  }
  onMount(() => {
    templateStore.subscribe((templateData) => {
      json = templateToJSON([])
      setTimeout(() => {
        json = templateToJSON(templateData)
      }, 50)
    })
  })
</script>

<div class:hidden={previewModal} class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 z-50 overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
    <div class="flex justify-center p-6 text-center mobile:p-12">
      <PreviewModal {json} on:click={closeModal} />
    </div>
  </div>
</div>
